
import React from "react";
import { NavLink } from "react-router-dom";
import "./BottomNavCopyTrading.css";

export default function BottomNavCopyTrading() {
  return (
    <nav className="bottom-copy-nav">
      <NavLink
        to="/copy-trading"
        end
        className={({ isActive }) =>
          `bottom-copy-nav-item ${isActive ? "active" : ""}`
        }
      >
        <span className="bottom-copy-nav-icon">📈</span>
        <span>Copy Trading</span>
      </NavLink>

      <NavLink
        to="/my-copy-trading-records"
        className={({ isActive }) =>
          `bottom-copy-nav-item ${isActive ? "active" : ""}`
        }
      >
        <span className="bottom-copy-nav-icon">📋</span>
        <span>My Copy Trading Records</span>
      </NavLink>
    </nav>
  );
}
